// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"41ed75a9e939a58945e7","339":"52e0a1f1e620985675d7"}[chunkId] + ".js";
};